/* eslint-disable camelcase */

import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import CreatableSelect from 'react-select/creatable'
import FormSelect from '../../ui/Select/FormSelect'
import { SELECT_STYLES, SELECT_THEME, MENU_PORTAL_TARGET } from '../../ui/Select/Select'
import DateInput from '../../ui/DateInput'
import { splitValue, joinValue, selectValue } from './helpers'

const INPUT_CLASS = 'tw:block tw:w-full tw:bg-white tw:text-sm tw:text-gray-800 tw:border'
  + ' tw:border-solid tw:border-gray-300 tw:rounded-md! tw:px-3 tw:py-2'
  + ' tw:focus:outline-none tw:focus:border-ds-primary!'

const TAGS_NO_OPTIONS = () => 'Tapez une valeur puis Entrée'
const formatTagLabel = input => `Ajouter "${input}"`
const tagsValue = value => splitValue(value).map(entry => ({ value: entry, label: entry }))

const ConditionValueField = ({ condition, kind, options, onValueChange }) => {
  const selected = splitValue(condition.value)

  const handleOption = useCallback(
    option => onValueChange(option ? option.value : null), [onValueChange]
  )
  const handleMulti = useCallback(
    chosen => onValueChange(joinValue((chosen || []).map(option => option.value))), [onValueChange]
  )
  const handleText = useCallback(event => onValueChange(event.target.value), [onValueChange])
  const handleDate = useCallback(value => onValueChange(value), [onValueChange])

  if (kind === 'option') {
    return (
      <FormSelect
        options={options}
        placeholder="Choisir une réponse"
        value={selectValue(options, condition.value)}
        menuPortal
        isClearable
        onChange={handleOption}
      />
    )
  }

  if (kind === 'option-multi') {
    return (
      <FormSelect
        options={options}
        placeholder="Choisir une ou plusieurs réponses"
        value={options.filter(option => selected.includes(option.value))}
        menuPortal
        isClearable
        isMulti
        onChange={handleMulti}
      />
    )
  }

  if (kind === 'tags') {
    return (
      <CreatableSelect
        options={[]}
        placeholder="Saisir une ou plusieurs valeurs"
        value={tagsValue(condition.value)}
        styles={SELECT_STYLES}
        theme={SELECT_THEME}
        menuPortalTarget={MENU_PORTAL_TARGET}
        formatCreateLabel={formatTagLabel}
        noOptionsMessage={TAGS_NO_OPTIONS}
        isMulti
        onChange={handleMulti}
      />
    )
  }

  if (kind === 'date' || kind === 'datetime' || kind === 'time')
    return <DateInput mode={kind} value={condition.value || ''} clearable onChange={handleDate} />

  return (
    <input
      className={INPUT_CLASS}
      type={kind === 'number' ? 'number' : 'text'}
      placeholder="Saisir une valeur"
      value={condition.value || ''}
      onChange={handleText}
    />
  )
}

ConditionValueField.propTypes = {
  condition: PropTypes.shape({
    targetable_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.string
  }).isRequired,
  kind: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }))
}

ConditionValueField.defaultProps = {
  options: []
}

export default ConditionValueField
